/* October sale signup.

   Posts our own form straight to Klaviyo's client subscription API, so the
   markup stays the design's rather than Klaviyo's form builder output, while
   Klaviyo still records the profile and the consent. SMS sending happens via
   Sinch off the Klaviyo sync, so all this has to get right is the consent.

   Email is required, mobile is optional. The consent line under the mobile
   field is what makes the SMS opt-in explicit, so it must stay visible.

   Guarded because both the steps band and the closing band ship this file.
*/
(function () {
  if (window.__oct26SignupReady) return;
  window.__oct26SignupReady = true;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var REVISION = '2025-01-15';

  // 0412 345 678 / 61412345678 / +61 412 345 678 all have to reach Klaviyo as
  // E.164, or the profile is created without a usable number.
  function toE164(raw) {
    var v = (raw || '').replace(/[^\d+]/g, '');
    if (!v) return '';
    if (v.charAt(0) === '+') return v;
    if (v.indexOf('61') === 0 && v.length >= 11) return '+' + v;
    if (v.charAt(0) === '0') return '+61' + v.slice(1);
    if (v.length === 9 && v.charAt(0) === '4') return '+61' + v;
    return '+' + v;
  }

  function submit(form) {
    var company = form.dataset.company;
    var list = form.dataset.list;
    var note = form.querySelector('[data-signup-note]');
    var btn = form.querySelector('button[type="submit"]');
    var email = (form.querySelector('[name="email"]') || {}).value || '';
    var name = (form.querySelector('[name="first_name"]') || {}).value || '';
    var phoneEl = form.querySelector('[name="phone"]');
    var phone = toE164(phoneEl ? phoneEl.value : '');

    email = email.trim();
    if (!email || email.indexOf('@') < 1) {
      say(note, form.dataset.msgEmail || 'Please enter your email address.', true);
      return;
    }
    if (!list) {
      say(note, form.dataset.msgError || 'Something went wrong. Please try again.', true);
      return;
    }

    var attrs = { email: email };
    if (name.trim()) attrs.first_name = name.trim();
    var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    if (phone) {
      attrs.phone_number = phone;
      subs.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    attrs.subscriptions = subs;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.dataset.source || 'October sale landing page',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Sending...'; }
    say(note, '', false);

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        // the endpoint answers 202 with an empty body on success
        if (r.status === 202 || r.ok) {
          var done = form.parentNode.querySelector('[data-signup-done]');
          if (done) { form.hidden = true; done.hidden = false; }
          else say(note, form.dataset.msgDone || 'You are on the list.', false);
          return;
        }
        throw new Error('status ' + r.status);
      })
      .catch(function () {
        say(note, form.dataset.msgError || 'Something went wrong. Please try again.', true);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Submit'; }
      });
  }

  function say(el, text, isError) {
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
    el.classList.toggle('is-error', !!isError);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-oct26-signup]') : null;
    if (!form) return;
    e.preventDefault();
    submit(form);
  });
})();
